"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M10 20h4V4h-4zm-6 0h4v-8H4zM16 9v11h4V9z"
}), 'EqualizerSharp');